import * as React from "react";
import {PositionHierarchyComponent} from "./PositionHierarchyComponent";

export class PositionHierarchyManagement extends React.Component {
  static PATH = "/position-hierarchy";


  render() {
    return <PositionHierarchyComponent/>;
  }
}
